import { css } from '@emotion/react';

/**
 * Gradient "Is this right for me?" welcome-heading treatment, shared by the logged-in
 * (FirstLearnerMessage) and logged-out (ChatZeroState) render paths so the gradient stays in sync
 * across both. Previously duplicated, which let one path drift to a stale value (MERCH-3116).
 */
export const gradientHeadingText = css`
  background: linear-gradient(279deg, #24dbe7 -5.78%, #6923de 12%);
  background-clip: text;
  color: transparent;
  display: inline-block;
`;
